/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboStructsEDRMachineSettingsCount
 */
export interface JumboStructsEDRMachineSettingsCount {
    /**
     * 
     * @type {number}
     * @memberof JumboStructsEDRMachineSettingsCount
     */
    notConfiguredCount?: number;
    /**
     * 
     * @type {number}
     * @memberof JumboStructsEDRMachineSettingsCount
     */
    notSetToRecommendedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof JumboStructsEDRMachineSettingsCount
     */
    setToRecommendedCount?: number;
}

/**
 * Check if a given object implements the JumboStructsEDRMachineSettingsCount interface.
 */
export function instanceOfJumboStructsEDRMachineSettingsCount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsEDRMachineSettingsCountFromJSON(json: any): JumboStructsEDRMachineSettingsCount {
    return JumboStructsEDRMachineSettingsCountFromJSONTyped(json, false);
}

export function JumboStructsEDRMachineSettingsCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsEDRMachineSettingsCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'notConfiguredCount': !exists(json, 'notConfiguredCount') ? undefined : json['notConfiguredCount'],
        'notSetToRecommendedCount': !exists(json, 'notSetToRecommendedCount') ? undefined : json['notSetToRecommendedCount'],
        'setToRecommendedCount': !exists(json, 'setToRecommendedCount') ? undefined : json['setToRecommendedCount'],
    };
}

export function JumboStructsEDRMachineSettingsCountToJSON(value?: JumboStructsEDRMachineSettingsCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'notConfiguredCount': value.notConfiguredCount,
        'notSetToRecommendedCount': value.notSetToRecommendedCount,
        'setToRecommendedCount': value.setToRecommendedCount,
    };
}

